import gql from "graphql-tag";

export const typeQueries = type => {
  if (type === "USER") {
    return {
      GET_DATA: gql`
        query DataUSER {
          users {
            _id
            name
          }
        }
      `,
      fieldNames: ["name"],
      typeName: "users"
    };
  }

  const typeName = JSON.parse(type.data).name;
  const fields = JSON.parse(type.data).fields;
  const fieldNames = fields.map(el => el.name);
  const fieldDeclaration = fields.map(el => {
    if (el.type === "relation") return el.name + "{_id value}";
    if (el.type === "numberAPI") return el.name + "{short long}";
    return el.name;
  });
  const GET_DATA = gql`
        query Data${typeName}($filters: [FilterInput], $limit: Int, $offset: Int) {
        ${typeName}(filters: $filters, limit: $limit, offset: $offset) {
        _id
                ${fieldDeclaration.join(" ")}
    }
}
`;

  const GET_AGGREGATIONS = gql`
        query Aggs${typeName}($fields: [FieldInput]) {
            ${typeName}Aggs(fields: $fields) {
                field
                values {
                    value
                    display
                    count
                }
            }
        }
    `;

  const GET_STATS = gql`
    query Stats${typeName} {
      ${typeName}Stats {
        totalCount
      }
    }
  `;

  const CREATE_DATA = gql`
        mutation Create${typeName}($data: ${typeName}Input!) {
        create${typeName}(input: $data)
  }
`;
  const UPDATE_DATA = gql`
    mutation Update${typeName}($id: String!, $data: ${typeName}Input!) {
        update${typeName}(id: $id, input: $data)
  }
`;
  const DELETE_DATA = gql`
    mutation Delete${typeName}($id: String!) {
        delete${typeName}(id: $id)
  }
`;
  return {
    typeName,
    fields,
    fieldNames,
    GET_DATA,
    CREATE_DATA,
    UPDATE_DATA,
    DELETE_DATA,
    GET_AGGREGATIONS,
    GET_STATS
  };
};
